import {AvalancheReelsDropOutState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsDropOutState';

export class TopAvalancheReelsDropOutState extends AvalancheReelsDropOutState {
	public onEnterState(): void {
		this.view.showAllSymbols();
		this.view.dropOut();
	}
}



// WEBPACK FOOTER //
// ./src/topreels/states/TopAvalancheReelsDropOutState.ts